import { IconName, IconPrefix } from '@fortawesome/pro-regular-svg-icons';
import { PCScreen } from 'components/guide/PCScreen';
import { MenuItem } from 'components/guide/menu/MenuItem';
import { motion } from 'framer-motion';
import { AnimTap } from 'libs/styles/styling';
import { useEffect } from 'react';
import { Link as Link2, scrollSpy } from 'react-scroll';
import styled from 'styled-components/macro';

export interface IHeaderMenu {
    title: string;
    iconSet: IconPrefix;
    iconName: IconName;
    link: string;
}

interface Props {
    items: IHeaderMenu[];
    logo: string;
    selectedItem?: string;
    className?: string;
}

export const HeaderMenu = (props: Props): JSX.Element => {
    useEffect(() => {
        scrollSpy.update();
    }, []);

    return (
        <S_HeaderMenu className={props.className}>
            <S_PCScreen>
                <S_Left>
                    <Link2 to="about" spy={true} smooth={true} offset={-50} duration={500}>
                        <S_Logo {...AnimTap} src={props.logo} />
                    </Link2>
                    <S_Items>
                        {props.items.map((item) => {
                            if (!item) return null;

                            return (
                                <Link2
                                    to={item.link}
                                    spy={true}
                                    smooth={true}
                                    offset={-135}
                                    duration={500}
                                    key={item.title}
                                >
                                    <MenuItem
                                        title={item.title}
                                        iconSet={item.iconSet}
                                        iconName={item.iconName}
                                        selected={props.selectedItem === item.link}
                                    />
                                </Link2>
                            );
                        })}
                    </S_Items>
                </S_Left>
            </S_PCScreen>
        </S_HeaderMenu>
    );
};

const S_HeaderMenu = styled.div`
    display: flex;
    width: 100%;
    min-height: 80px;
    background: #fff;
    box-shadow: 9.002px 9.002px 45.012px 0px rgba(0, 0, 0, 0.1);
    align-items: center;
`;

const S_Logo = styled(motion.img)`
    display: flex;
    cursor: pointer;
    margin: 0 35px 0 0;
    height: 55px;
`;

const S_PCScreen = styled(PCScreen)`
    display: flex;
    justify-content: space-between;
    padding: 10px 0;
`;

const S_Left = styled.div`
    display: flex;
    align-items: center;
`;

const S_Items = styled.div`
    display: flex;
    align-items: center;
    gap: 15px;
    width: 100%;
    flex-wrap: wrap;
`;
